function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
var inputRegex = /^\s*(\[([( |x])?\])\s$/;
var TaskItem = Node.create({
  name: 'taskItem',
  addOptions: function addOptions() {
    return {
      nested: false,
      HTMLAttributes: {},
      taskListTypeName: 'taskList'
    };
  },
  content: function content() {
    return this.options.nested ? 'paragraph block*' : 'paragraph+';
  },
  defining: true,
  addAttributes: function addAttributes() {
    return {
      checked: {
        default: false,
        keepOnSplit: false,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('data-checked') === 'true';
        },
        renderHTML: function renderHTML(attributes) {
          return {
            'data-checked': attributes.checked
          };
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: "li[data-type=\"".concat(this.name, "\"]"),
      priority: 51
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var node = _ref.node,
        HTMLAttributes = _ref.HTMLAttributes;
    return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      'data-type': this.name
    }), ['label', ['input', {
      type: 'checkbox',
      checked: node.attrs.checked ? 'checked' : null
    }], ['span']], ['div', 0]];
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this = this;

    var shortcuts = {
      Enter: function Enter() {
        return _this.editor.commands.splitListItem(_this.name);
      },
      'Shift-Tab': function ShiftTab() {
        return _this.editor.commands.liftListItem(_this.name);
      }
    };

    if (!this.options.nested) {
      return shortcuts;
    }

    return _objectSpread(_objectSpread({}, shortcuts), {}, {
      Tab: function Tab() {
        return _this.editor.commands.sinkListItem(_this.name);
      }
    });
  },
  addNodeView: function addNodeView() {
    var _this2 = this;

    return function (_ref2) {
      var node = _ref2.node,
          HTMLAttributes = _ref2.HTMLAttributes,
          getPos = _ref2.getPos,
          editor = _ref2.editor;
      var listItem = document.createElement('li');
      var checkboxWrapper = document.createElement('label');
      var checkboxStyler = document.createElement('span');
      var checkbox = document.createElement('input');
      var content = document.createElement('div');
      checkboxWrapper.contentEditable = 'false';
      checkbox.type = 'checkbox';
      checkbox.addEventListener('change', function (event) {
        // if the editor isn’t editable and we don't have a handler for
        // readonly checks we have to undo the latest change
        if (!editor.isEditable && !_this2.options.onReadOnlyChecked) {
          checkbox.checked = !checkbox.checked;
          return;
        }

        var checked = event.target.checked;

        if (editor.isEditable && typeof getPos === 'function') {
          editor.chain().focus(undefined, {
            scrollIntoView: false
          }).command(function (_ref3) {
            var tr = _ref3.tr;
            var position = getPos();
            var currentNode = tr.doc.nodeAt(position);
            tr.setNodeMarkup(position, undefined, _objectSpread(_objectSpread({}, currentNode === null || currentNode === void 0 ? void 0 : currentNode.attrs), {}, {
              checked: checked
            }));
            return true;
          }).run();
        }

        if (!editor.isEditable && _this2.options.onReadOnlyChecked) {
          // Reset state if onReadOnlyChecked returns false
          if (!_this2.options.onReadOnlyChecked(node, checked)) {
            checkbox.checked = !checkbox.checked;
          }
        }
      });
      Object.entries(_this2.options.HTMLAttributes).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        listItem.setAttribute(key, value);
      });
      listItem.dataset.checked = node.attrs.checked;

      if (node.attrs.checked) {
        checkbox.setAttribute('checked', 'checked');
      }

      checkboxWrapper.append(checkbox, checkboxStyler);
      listItem.append(checkboxWrapper, content);
      Object.entries(HTMLAttributes).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            value = _ref7[1];

        listItem.setAttribute(key, value);
      });
      return {
        dom: listItem,
        contentDOM: content,
        update: function update(updatedNode) {
          if (updatedNode.type !== _this2.type) {
            return false;
          }

          listItem.dataset.checked = updatedNode.attrs.checked;

          if (updatedNode.attrs.checked) {
            checkbox.setAttribute('checked', 'checked');
          } else {
            checkbox.removeAttribute('checked');
          }

          return true;
        }
      };
    };
  },
  addInputRules: function addInputRules() {
    return [wrappingInputRule({
      find: inputRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        return {
          checked: match[match.length - 1] === 'x'
        };
      }
    })];
  }
});
export { TaskItem, TaskItem as default, inputRegex };